import {
  guardAction,
  guardLoader,
  orderAheadManageGate,
  orderAheadSetupGate,
} from "../../order-ahead/guards";
import {
  ActionFunctionArgs,
  Outlet,
  redirect,
  useLocation,
  useNavigate,
} from "react-router-dom";
import toast from "react-hot-toast";
import { Breadcrumb } from "../../../components/Breadcrumb";
import {
  OrderAheadLocationEdit, orderAheadLocationEditAction, orderAheadLocationEditLoader,
} from "./OrderAheadLocationEdit";
import { Item } from "../../../types/item";
import {
  OrderAheadLocationCreate, orderAheadLocationCreateAction, orderAheadLocationCreateLoader
} from "./OrderAheadLocationCreate";
import { createApolloClient } from "../../../providers/ApolloClientFactory";
import {DELETE_ORDER_AHEAD_LOCATION} from "./mutations";
import {
  OrderAheadLocationClone, orderAheadLocationCloneAction, orderAheadLocationCloneLoader
} from "./OrderAheadLocationClone";
import { OrderAheadLocationList, orderAheadLocationsListLoader } from "./OrderAheadLocationList";

const client = createApolloClient();

const OrderAheadLocationIndex = () => {
  const location = useLocation();
  const navigate = useNavigate();

  if (location.pathname === "/order-ahead-locations") {
    navigate(`/order-ahead-locations/list`);
  }

  return (
    <>
      <Outlet />
    </>
  );
};

const orderAheadLocationDeleteAction = async ({ params }: ActionFunctionArgs) => {
  const { id } = params;
  try {
    await client.mutate({
      mutation: DELETE_ORDER_AHEAD_LOCATION,
      variables: { id },
    });
    toast.success("Order Ahead Location Deleted");
    return redirect(`/order-ahead/overview`);
  } catch {
    toast.error("Failed To Delete Order Ahead Location");
    return null;
  }
};

export const orderAheadLocationsRouter = {
  path: "/order-ahead-locations",
  id: "order-ahead-locations",
  // Parent allows viewers in; the write children add the Manage check.
  loader: guardLoader(orderAheadSetupGate),
  element: <OrderAheadLocationIndex />,
  handle: {
    crumb: () => <Breadcrumb name="Order Ahead Locations" href="/order-ahead/overview" />,
  },
  children: [
    {
      path: "list",
      id: "order-ahead-locations-list",
      element: <OrderAheadLocationList />,
      loader: guardLoader(orderAheadSetupGate, orderAheadLocationsListLoader),
    },
    {
      path: "create",
      id: "order-ahead-locations-create",
      element: <OrderAheadLocationCreate />,
      action: guardAction(orderAheadManageGate, orderAheadLocationCreateAction),
      loader: guardLoader(orderAheadManageGate, orderAheadLocationCreateLoader),
      handle: {
        crumb: () => <Breadcrumb name={`Create Order Ahead Location`} href={`/order-ahead-locations/create`} />,
      },
    },
    {
      path: ":id/edit",
      id: "order-ahead-locations-edit",
      element: <OrderAheadLocationEdit />,
      loader: guardLoader(orderAheadManageGate, orderAheadLocationEditLoader),
      action: guardAction(orderAheadManageGate, orderAheadLocationEditAction),
      handle: {
        crumb: (data: Item) => (
          <Breadcrumb
            name={`Edit ${data.name}`}
            href={`/order-ahead-locations/${data.id}/edit`}
          />
        ),
      },
    },
    {
      path: ":id/clone",
      id: "order-ahead-locations-clone",
      element: <OrderAheadLocationClone />,
      action: guardAction(orderAheadManageGate, orderAheadLocationCloneAction),
      loader: guardLoader(orderAheadManageGate, orderAheadLocationCloneLoader),
    },
    {
      path: ":id/delete",
      id: "order-ahead-locations-delete",
      action: guardAction(orderAheadManageGate, orderAheadLocationDeleteAction),
    },
  ],
};
